<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="selectedUrl ? `crud/${inputs.id}` : `crud`"
			>
				<!-- Date -->
				<div class="form-group row align-items-center">
					<label for="input_date" class="col-sm-3 mb-0"> Date </label>
					<app-input
						id="input_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.date"
						placeholder="Date"
						:required="true"
					/>
				</div>
				<!-- From -->
				<div class="form-group row align-items-center">
					<label for="inputs_from" class="col-sm-3 mb-0">
						From
					</label>
					<app-input
						id="inputs_from"
						class="col-sm-9"
						type="text"
						v-model="inputs.from"
						placeholder="From"
						:required="true"
					/>
				</div>
				<!-- Comment -->
				<div class="form-group row align-items-center">
					<label for="inputs_comment" class="col-sm-3 mb-0">
						Comment
					</label>
					<app-input
						id="inputs_comment"
						class="col-sm-9"
						type="text"
						v-model="inputs.comment"
						placeholder="Comment"
						:required="true"
					/>
				</div>
				<!-- Task -->
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_task" class="col-sm-3 mb-0">
						Task
					</label>
					<app-input
						id="inputs_task"
						class="col-sm-9"
						type="text"
						v-model="inputs.name"
						placeholder="Task"
						:required="true"
					/>
				</div> -->
				<!-- Assigned By -->
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_assigned_by" class="col-sm-3 mb-0">
						Assigned By
					</label>
					<app-input
						id="inputs_assigned_by"
						class="col-sm-9"
						type="text"
						v-model="inputs.name"
						placeholder="Assigned By"
						:required="true"
					/>
				</div> -->
				<!-- To Be Completed By -->
				<!-- <div class="form-group row align-items-center">
					<label
						for="inputs_to_be_completed_by"
						class="col-sm-3 mb-0"
					>
						To Be Completed By
					</label>
					<app-input
						id="inputs_to_be_completed_by"
						class="col-sm-9"
						type="text"
						v-model="inputs.name"
						placeholder="To Be Completed By"
						:required="true"
					/>
				</div> -->
				<!-- Due Date -->
				<!-- <div class="form-group row align-items-center">
					<label for="input_due_date" class="col-sm-3 mb-0">
						Due Date
					</label>
					<app-input
						id="input_due_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.due_date"
						placeholder="Due Date"
						:required="true"
					/>
				</div> -->
				<!-- Due Time -->
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_due_time" class="col-sm-3 mb-0">
						Due Time
					</label>
					<app-input
						id="inputs_due_time"
						class="col-sm-9"
						type="time"
						v-model="inputs.due_time"
						placeholder="Due Time"
						:required="true"
					/>
				</div> -->
				<!-- Status -->
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_status" class="col-sm-3 mb-0">
						Status
					</label>
					<app-input
						id="inputs_status"
						class="col-sm-9"
						type="text"
						v-model="inputs.status"
						placeholder="Status"
						:required="true"
					/>
				</div> -->
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
	name: "MarketingHdykTableForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
	},
	data() {
		return {
			preloader: false,
			inputs: {},
			phone: "",
			modalId: this.formId,
			modalTitle: this.$t("add"),
			interested_in_list: [
				{ id: "interested_in_1", value: "Interested In 1" },
				{ id: "interested_in_2", value: "Interested In 2" },
				{ id: "interested_in_3", value: "Interested In 3" },
			],
			nearest_clc_list: [
				{ id: "nearest_clc_1", value: "Nearest CLC 1" },
				{ id: "nearest_clc_2", value: "Nearest CLC 2" },
				{ id: "nearest_clc_3", value: "Nearest CLC 3" },
			],
			sub_status_list: [
				{ id: "active", value: "Active" },
				{ id: "inactive", value: "Inactive" },
				{ id: "invited", value: "Invited" },
			],
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			if (response.data.phone) this.phone = response.data.phone;
			this.inputs = response.data;
			this.preloader = false;
		},
	},
};
</script>
